import React, { useMemo } from 'react';
import { Bar } from 'react-chartjs-2';
import { ChartOptions } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { useIntl } from 'react-intl';
import { VisualizerMonthData } from '../../models';
import { VisualizerService } from '../../services';

type Props = {
  month: VisualizerMonthData;
  maxWidth: number;
}

export default function VisualizerMonthlyChart({ month, maxWidth }: Props) {
  const intl = useIntl();
  const chartData = useMemo(() => VisualizerService.convertMonthToChartData(month, intl), [month, intl]);
  const stackedChartOptions: ChartOptions<'bar'> = useMemo(() => ({
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: 'y',
    animation: false,
    barThickness: 21,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,
      },
      datalabels: {
        display: true,
        color: (value) => {
          if (value.dataset.label === 'Regular') return 'white';
          return 'black';
        },
        anchor: 'center',
        align: 'center',
        font: {
          weight: 'bold',
        },
        formatter: (value, context) => {
          const { datasetIndex } = context;
          const { width } = context.chart.getDatasetMeta(datasetIndex).data[0] as any;
          if (width > 30) return Math.round(value).toString();
          return '';
        },
      },
    },
    scales: {
      x: {
        type: 'linear',
        display: false,
        stacked: true,
        ticks: {
          display: true,
        },
        grid: {
          display: false,
        },
        max: maxWidth,
      },
      y: {
        display: false,
        stacked: true,
        ticks: {
          display: true,
        },
        grid: {
          display: false,
        },
      },
    },
    elements: {
      bar: {
        borderSkipped: false,
      },
    },
  }), [maxWidth]);

  return (
    <Bar data={chartData} options={stackedChartOptions} plugins={[ChartDataLabels]} aria-label={`visualizerBarChart${month.month}`} />
  );
}
